import { motion } from "framer-motion";
import { GraduationCap } from "lucide-react";
import { useEducation } from "@/hooks/usePortfolio";
import { SectionTitle } from "@/components/SectionTitle";

const yr = (d) => (d ? new Date(d).getFullYear() : "");

export const Education = () => {
  const { data: education, isLoading, error } = useEducation();

  if (isLoading || error || !education) return null;

  const sortedEducation = [...education].sort((a, b) => a.displayOrder - b.displayOrder);

  return (
    <section id="education" className="section-pad relative" data-testid="education-section">
      <div className="container-x">
        <SectionTitle eyebrow="Academia" title={<>Educational <span className="italic gold-text">foundation</span></>} subtitle="Grounded in engineering. Built for business." />
        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {sortedEducation.map((e, i) => (
            <motion.div
              key={e.id}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`education-${e.id}`}
              className="glass rounded-2xl p-7 grain"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-xl bg-[hsl(var(--gold))]/12 border border-[hsl(var(--gold))]/30 flex items-center justify-center">
                  <GraduationCap className="w-6 h-6 text-[hsl(var(--gold-deep))] dark:text-[hsl(var(--gold-light))]" />
                </div>
                <div className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground">{yr(e.startDate)} — {yr(e.endDate)}</div>
              </div>
              <h3 className="font-serif text-2xl leading-tight">{e.degree}</h3>
              <div className="mt-1 text-sm text-[hsl(var(--gold-deep))] dark:text-[hsl(var(--gold-light))]">{e.fieldOfStudy}</div>
              <div className="mt-3 text-sm font-medium">{e.institutionName}</div>
              <p className="mt-4 text-sm text-muted-foreground leading-relaxed">{e.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
